module.exports = __webpack_public_path__ + "img/B.ed4a1507.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shot-images/B.jpg
// module id = ZU8B
// module chunks = 1